var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg3456377(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Outline",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m376 16h-176a40.045 40.045 0 0 0 -40 40v152h-24a40.045 40.045 0 0 0 -40 40v100.687l-24 24-10.343-10.344a8 8 0 0 0 -11.314 0l-32 32a8 8 0 0 0 0 11.314l80 80a8 8 0 0 0 11.314 0l32-32a8 8 0 0 0 0-11.314l-2.343-2.343 20.686-20.686v4.686a40.045 40.045 0 0 0 40 40h176a40.045 40.045 0 0 0 40-40v-368a40.045 40.045 0 0 0 -40-40zm-272 452.687-68.686-68.687 20.686-20.687 68.686 68.687zm-20.686-84.687 26.343-26.343a8 8 0 0 0 2.343-5.657v-104a24.028 24.028 0 0 1 24-24h24v37.754l-22.06-5.515-3.88 15.522 18.292 4.573-14.009 14.009 11.314 11.314 40-40a14.628 14.628 0 0 1 20.686 20.687l-40 40a8 8 0 0 0 0 11.314 37.254 37.254 0 0 1 0 52.686l-42.343 42.342zm316.686 40a24.027 24.027 0 0 1 -24 24h-176a24.027 24.027 0 0 1 -24-24v-20.686l5.657-5.657a53.282 53.282 0 0 0 5.238-69.238l34.762-34.763a30.627 30.627 0 1 0 -43.314-43.313l-2.343 2.343v-196.686a24.027 24.027 0 0 1 24-24h176a24.027 24.027 0 0 1 24 24z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m280 416h16v16h-16z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m296 48h16v16h-16z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m264 48h16v16h-16z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m216 336h144v16h-144z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m216 368h128v16h-128z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m232 304h128v16h-128z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m280 272h80v16h-80z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m248 272h16v16h-16z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m432 120h16v200h-16z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m432 336h16v16h-16z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m371.151 120.646-56-24a8 8 0 0 0 -8.808 1.7l-18.343 18.341-18.343-18.344a8 8 0 0 0 -8.808-1.7l-56 24a8 8 0 0 0 -4.61 9.294l8 32a8 8 0 0 0 9.7 5.821l22.061-5.512v69.754a8 8 0 0 0 8 8h80a8 8 0 0 0 8-8v-69.754l22.06 5.515a8 8 0 0 0 9.7-5.821l8-32a8 8 0 0 0 -4.609-9.294zm-16.972 29.654-24.239-6.06a8 8 0 0 0 -9.94 7.76v72h-64v-72a8 8 0 0 0 -9.94-7.761l-24.239 6.06-4.407-17.63 44.759-19.183 20.17 20.171a8 8 0 0 0 11.314 0l20.17-20.171 44.759 19.183z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3456377);
export default __webpack_public_path__ + "static/media/3456377.79ee0fb6.svg";
export { ForwardRef as ReactComponent };